import React from 'react'

function TechSelection() {
  return (
    <embed src="\pdfs\E1.5.2_VA-RV_VA-RN_Rectangular_displacement_outlet_06.2012_kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelection